import React from 'react';
import styled from 'styled-components';

const RoomType = ({roomType, numberOfRooms}) => (
  <RoomTypeWrapDiv>
    <RoomTypeTxtPara>
      {numberOfRooms} x {roomType}
    </RoomTypeTxtPara>
    {/* <RoomDetailLink>Room Details</RoomDetailLink> */}
  </RoomTypeWrapDiv>
);

export default RoomType;

const RoomTypeWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  justify-content: space-between;
  padding:${props.theme.spacing.large.l15} ${props.theme.spacing.large.l20};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.grey.lighte7};
`,
);

const RoomTypeTxtPara = styled.p(
  props => `
    font-size:${props.theme.font.large.font16};
    color:${props.theme.colors.black.base};
    font-weight:${props.theme.font.fontWeight.black};
    font-family:${props.theme.font.fontFamily};

`,
);

const RoomDetailLink = styled.p(
  props => `
    align-self: flex-end;
    justify-content: flex-end;
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.blue.base};
    font-weight: ${props.theme.font.fontWeight.black};
    cursor: pointer;
  `
)